import { render } from "./AbonQueue.vue?vue&type=template&id=905b1f8e"
import script from "./AbonQueue.vue?vue&type=script&lang=js"
export * from "./AbonQueue.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__